<script>
  import { fade } from "svelte/transition";
</script>

<style>

</style>

<div>
  <p in:fade={{ duration: 200 }}>
    This project was inspired by
    <a href="https://nytimes.com">this visualization</a>
    from the New York Times where users plotted Game of Thrones characters on an
    XY axis based on physical beauty and morality. I began wondering how data
    visualization techniques that help us describe data may also be used as
    tools in gathering data interactively. With this first survey, the aim is to
    include participants in how their data is visually charted in order to
    improve the quality and accuracy of their response
  </p>

</div>
